import React from "react"
import { ColorBackgroundProps } from "../types/color"

export const ColorBackground = (props: ColorBackgroundProps) => {
    return (
        <div style={{
            backgroundColor: props.colorCode,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "15%",
            zIndex: -1,
        }}/>
    )
}


// WEBPACK FOOTER //
// ./src/common/color/ColorBackground.tsx